import axios from 'axios';

const BASE_URL = '/app/funnel';

export const subscriptionsByProduct = async () => {
    const { data: { subscriptions } } = await axios.get(`${BASE_URL}/async/cancelSubscription`);

    return subscriptions;
};
